{
  "jira-pandora.jira-project-access-granted.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "jira-pandora.jira-project-access-granted.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "jira-pandora.jira-project-access-granted.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-pandora.jira-project-access-granted.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "jira-pandora.jira-project-access-granted.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "jira-pandora.jira-project-access-granted.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "jira-pandora.jira-project-access-granted.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.body.content.no-translate": [
    {
      "type": 0,
      "value": "Users have requested to join your Jira project"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.button.text.no-translate": [
    {
      "type": 0,
      "value": "View access requests"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Access request for "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "jira-pandora.jira-project-access-requested.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "jira-pandora.jira-project-access-requested.test-message.email.body.message.no-translate": [
    {
      "type": 1,
      "value": "message"
    }
  ],
  "jira-pandora.jira-project-access-requested.test-message.email.body.no-translate": [
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " has requested access to project "
    },
    {
      "type": 1,
      "value": "projectKey"
    }
  ],
  "jira-pandora.jira-project-access-requested.test-message.email.button.text.no-translate": [
    {
      "type": 0,
      "value": "View Request"
    }
  ],
  "jira-pandora.jira-project-access-requested.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira.jira-notify-reaction.message-template.text.single-reaction-with-name": [
    {
      "type": 0,
      "value": ":bell: *"
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " reacted to your comment*"
    }
  ],
  "jira.jira-notify-reaction.message-template.text.view-comment": [
    {
      "type": 0,
      "value": "View comment"
    }
  ]
}